export default {
  type: 'user_taggings',
  relationships: {
    user_tags: { type: 'user_tags' },
    training_classes: { type: 'training_classes' },
  },
};
